import cn from 'classnames';
import React from 'react';
import { useStratsContext } from '@/finsight/application/Strats/StratsContext';
import Spinner from '@dealroadshow/uikit/core/components/Loader/Spinner';
import stratsStyles from '@/finsight/ui/components/strats/strats.scss';
import styles from './datatapeTable.scss';
import cardStyles from '@dealroadshow/uikit/core/styles/card.scss';
import { getSummaryValue } from '@/finsight/ui/components/strats/helpers';

const reduceTableData = (result, row) => {
  if ('subTotals' in row) {
    return [
      ...result,
      {
        ...row,
        hasSubTotals: true,
      },
      ...row.subTotals,
    ];
  }
  return [
    ...result,
    row,
  ];
};

const renderTable = (firstSection, secondSection = []) => {
  const valueColCls = cn(styles.col, styles.value);

  return firstSection.map((item, i) => (
    <div
          /* TODO: Oles Bolotniuk, maybe use item.id, not sure if it's there */
          /* eslint-disable-next-line react/no-array-index-key */
      key={ i }
      className={ styles.row }
      data-test={ `row[${ i }]` }
    >
      <div className={ cn(styles.col, styles.label, { [styles.hasSubTotals]: item.hasSubTotals }) }>
        { item.label }
      </div>
      <div className={ valueColCls }>
        { getSummaryValue(item.label, item.value) }
      </div>
      { secondSection[i] && (
        <>
          <div className={ cn(styles.col, styles.label, { [styles.hasSubTotals]: secondSection[i].hasSubTotals }) }>
            { secondSection[i].label }
          </div>
          <div className={ valueColCls }>
            { getSummaryValue(secondSection[i].label, secondSection[i].value) }
          </div>
        </>
        ) }
    </div>
  ));
};

const renderTableForLargeScreen = (data) => renderTable(data[0], data[1].reduce(reduceTableData, []));

const renderTableForSmallScreen = (data) => data.map((rows) => renderTable(rows.reduce(reduceTableData, [])));

const DatatapeTable = () => {
  const { metadata: { totals } } = useStratsContext();
  return (
    <div
      id="table-summary"
      className={ styles.datatapeTableCol }
      data-test="stratMakerDatatapeTable"
    >
      <div className={ cn(cardStyles.cardContainer, styles.card) }>
        <div className={ stratsStyles.panelHeader }>
          <h3 data-test="datatapeTitle">StratMaker Datatape Summary</h3>
          <Spinner
            isVisible={ !totals.length }
            className={ stratsStyles.panelSpinner }
          />
        </div>
        { !!totals.length && (
          <>
            <div className={ styles.datatapeTableContainerForLargeScreens }>
              { renderTableForLargeScreen(totals) }
            </div>
            <div className={ styles.datatapeTableContainerForSmallScreens }>
              { renderTableForSmallScreen(totals) }
            </div>
          </>
          ) }
      </div>
    </div>
  );
};

export default DatatapeTable;
